export const SPARTAN_SLIDER_NAV_LABELS = {
  ariaLabel: 'Slider navigation',
  carousel: 'Carousel',
  prev: 'Previous',
  next: 'Next',
} as const;

export const SPARTAN_SLIDER_NAV_BUTTON_CLASS_NAME =
  'size-10 shrink-0 rounded-full bg-gray-800 p-3';

export const SPARTAN_SLIDER_NAV_WHITE_DISABLED_BUTTON_CLASS_NAME =
  'disabled:bg-gray-800 disabled:text-gray-400';
